import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  cancel: {
    defaultMessage: 'Cancel',
    id: '2gwY06',
    description: 'Text for a cancel button that cancels creating a new return',
  },
  skipItemsStepText: {
    defaultMessage: 'Skip this step',
    id: 'XTvrZU',
    description: 'Text for a button that allows users to skip the step of choosing return items in the new return creation flow',
  },
  chooseItemsStepText: {
    defaultMessage: 'Choose Items',
    id: '3d3gZk',
    description: 'Text indicating that the user is in the "Choose Items" step of the new return creation process',
  },
  continue: {
    defaultMessage: 'Continue',
    id: 'D6XWrv',
    description: 'Text for a continue button that continues to the next step in creating a new return',
  },
});
